import { Injectable, inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/services/toast.service';

@Injectable()
export class EjecutivosCementoUiEffectsService {
  private readonly toast = inject(ToastService);
  private readonly spinner = inject(NgxSpinnerService);

  syncLoading(isLoading: boolean): void {
    if (isLoading) {
      this.spinner.show();
      return;
    }
    this.spinner.hide();
  }

  showLoadError(): void { this.toast.showAdminError('No se pudieron cargar los ejecutivos.'); }
  showCreateSuccess(): void { this.toast.showAdminSuccess('Ejecutivo creado correctamente.'); }
  showCreateError(message = 'Error al crear el ejecutivo.'): void { this.toast.showAdminError(message); }
  showUpdateSuccess(): void { this.toast.showAdminSuccess('Ejecutivo actualizado correctamente.'); }
  showUpdateError(message = 'Error al actualizar el ejecutivo.'): void { this.toast.showAdminError(message); }
  showDeactivateSuccess(): void { this.toast.showAdminSuccess('Ejecutivo desactivado correctamente.'); }
  showDeactivateError(): void { this.toast.showAdminError('Error al desactivar el ejecutivo.'); }
  showReactivateSuccess(): void { this.toast.showAdminSuccess('Ejecutivo reactivado correctamente.'); }
}
